// extracted by mini-css-extract-plugin
export default {"logo":"_5Ty6K5vwbMMom9+LT6weuw==","DE":"XxGt39pC92cUrLLMVyeBRg=="};